import { ReactNode } from 'react';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

interface Props {
  children: ReactNode;
  header: string;
  icon?: Icon;
}

const Perk = ({ children, header, icon }: Props) => (
  <div className={'flex flex-col md:flex-row'}>
    <div className="flex items-center justify-center pr-0 text-perk-header-color md:pr-3 md:flex-row">
      <IconView icon={icon} />
      <div className="pl-2 md:hidden">{header}</div>
    </div>
    <div className="flex flex-1 text-center justify-center text-perk-text-color">
      {children}
    </div>
  </div>
);

export default Perk;
